import { Text } from "@fluentui/react-components";
import { Edit24Regular, FormNew24Regular } from "@fluentui/react-icons";

import { useOptionDrawerStore } from "../store/OptionDrawerStore";

import BaseDrawer from "../../../components/BaseDrawer";

import OptionForm from "./OptionForm";
import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useCategoryContext } from "../context/CategoryContext";
import { useDeleteOptionMutation } from "../api/DeleteOption";
import { useCategoryTabStore } from "../store/CategoryTabStore";
import OverlaySpinner from "../../../components/OverlaySpinner";

export default function OptionDrawer() {
    const { selectedCategory: category } = useCategoryTabStore();
    const { isEdit, isOpen, close, data: option } = useOptionDrawerStore();
    const { showDialog, showNotification } = useUtilitiesContext();
    const { refetchOptions } = useCategoryContext();

    const deleteMutation = useDeleteOptionMutation(
        () => {
            showNotification({
                type: "success",
                title: "Deleted",
                message: <Text>The option <b>{option?.name}</b> is pending approval for deletion.</Text>,
                
            });
            refetchOptions();
            close();
        },
        (error: Error) => {
            showNotification({
                type: "error",
                title: "Error",
                message: error.message,
            });
        }
    );
    const handleDelete = () => {
        console.log(option, category);
        if (option && category) {
            showDialog({
                title: "Delete Option",
                content: <Text>Are you sure you want to delete option <b>{option.name}</b> ?</Text>,
                primaryActionText: "Yes",
                primaryAction: () => deleteMutation.mutate({categoryId: category.id, optionId: option.id}),
                secondaryActionText: "No",
                secondaryAction: () => { },
            });
        }
    };

    const drawerTitle = isEdit ? "Edit option" : "New option";
    const drawerIcon = isEdit ? <Edit24Regular /> : <FormNew24Regular />;

    return (
        <BaseDrawer
            title={drawerTitle}
            icon={drawerIcon}
            size="small"
            isOpen={isOpen}
            close={close}
            removable={isEdit}
            remove={handleDelete}
        >
            <OverlaySpinner open={deleteMutation.isPending} label="Deleting..." />
            <OptionForm />
        </BaseDrawer>
    )
}